import { useMemo } from 'react';
import useSWR from 'swr';
import { useAuth } from '../../auth/auth.hook';
import { useConfig } from '../../config/config.hook';
import { PerfilAluno, PerfilEducador, useUsuario } from '../../usuario';
import { consultaListaTurmasAtuaisService } from '../services/consulta-lista-turmas-atuais/consulta-lista-turmas-atuais.service';
import { paraTurmaAtual } from './mappers/para-turma-atual/para-turma-atual.mapper';
import { Hook } from './turmas-atuais.types';

export const useTurmasAtuais: Hook = () => {
  const { token } = useAuth();
  const { domain } = useConfig();
  const { get: getUsuario } = useUsuario();

  const usuario = domain === 'aluno' ? getUsuario<PerfilAluno>() : getUsuario<PerfilEducador>();

  const emailUtilizado = useMemo(() => usuario.aura.dados.emailUtilizado, [usuario.aura.dados.emailUtilizado]);

  const urlBase = useConfig().getValueOrThrow<string>('API_DEDICADA');

  const { data, isLoading, isValidating, error } = useSWR(
    emailUtilizado ? ['lista-turmas-atuais', emailUtilizado] : null,
    async () => paraTurmaAtual({ apiResponse: await consultaListaTurmasAtuaisService({ urlBase, token }) }),
    {
      revalidateOnMount: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
      dedupingInterval: 180000,
    },
  );

  const result = useMemo(
    () => ({
      turmas: data || [],
      pendente: isLoading || isValidating,
      erro: !!error,
    }),
    [data, error, isLoading, isValidating],
  );

  return result;
};
